import { CpsDocumentForm, Footer } from '@cs-cms/ui';
import { CpsGrid } from '../../../../../packages/ui/src/grid/CpsGrid';
import CpsPage from '../../../../../packages/ui/src/pages/CpsPage';
import TopBar from '../../../../../packages/ui/src/topBar/TopBar';

export const DocumentWorkspace: React.FC = () => {
  return (
    <CpsPage>
      <TopBar />
      <CpsGrid />
      <CpsDocumentForm />
      <Footer />
    </CpsPage>
  );
};
